import { MblStatusViewModel, OceanMblStatusMap, OiContainerEvents } from "../../../../fms.core/MblStatusViewModel";
import { GenMain } from "../../../../fms.core/GenMain";
import { PimsContainer } from "../../../../fms.core/pims/PimsContainer";
import { PimsCntrEvent } from "../../../../fms.core/PimsCntrEvent";
import { CargoEventLog } from '../../../../fms.core/CargoEventLog';
import { now } from '../../../../dateUtils';
import { getFmsGlobal } from '../../../../globals';
import _ from "lodash";
import moment from "moment";

export function formatLclFcl(f:string|null|undefined) {
  if (f === 'L') {
    return 'Consol';
  } else if (f === 'F') {
    return 'FCL';
  } else if (f === 'O') {
    return 'LCL';
  }

  return '';
}

//[save-sqlinfo]
export const mblStatusName = {
  rcvAnFromCarr: 'rcvAnFromCarr',
  sendAnToCust: 'sendAnToCust',
  eblDate: 'eblDate',
  rcvCrDb: 'rcvCrDb',
  rlsDate: 'rlsDate',
  customsHold: 'customsHold',
  customRls: 'customRls',
  cfsDate: 'cfsDate',
  arrngTruck: 'arrngTruck',
  sendPuDelInst: 'sendPuDelInst',
  sendPod: 'sendPod',
  emptyRtnDate: 'emptyRtnDate'
}

/**
 * [save-sqlinfo]
 * Do remaining initialization after read Entity
 * @param mbl 
 */
 export function prepareOtherOpForView(mbl:GenMain) {
  // Init milestone
  if(!mbl.milestone) {
    mbl.milestone = new MblStatusViewModel();
  }
  if(mbl.milestone.eventItemList.length > 0) {
    _.remove(mbl.milestone.eventItemList);
  }

  if(mbl.milestone.cntrItemList == null) mbl.milestone.cntrItemList = [];
  if(mbl.milestone.eventItemList == null) mbl.milestone.eventItemList = [];

   if (!mbl.milestone.cntrItemList || mbl.milestone.cntrItemList.length === 0) {
     AddPimsCntrEvent(mbl, new PimsContainer({ bookingId: 0, cntrNo: mbl.mblNo }))
   }
   else {
     mbl.milestone.cntrItemList.forEach(x => {
       AddPimsCntrEvent(mbl, x)
     })
   }
 }

function AddPimsCntrEvent(mbl:GenMain, pimsContainer:PimsContainer){
  OiContainerEvents.forEach((enumEvent) => {
    // let seqNo = 0;
    const smitem = OceanMblStatusMap.get(enumEvent);
    if(!smitem) return;
    mbl.milestone?.eventItemList?.push(new PimsCntrEvent({
      pimsCntrId: pimsContainer.id,
      cntrNo: pimsContainer.cntrNo,
      pickupNo: pimsContainer.pickupNo,
      name: smitem.label,
      lastDate: _.get(pimsContainer, smitem.pimsCntrDate??''),
      locName: _.get(pimsContainer, smitem.pimsCntrLoc??''),
      seq: enumEvent,   //seqNo++,
      isVisible: true
    }));
  });
}

export function AddEventToNotice(dicEvent: { key: string, value: string }[], evtCode: string, pimsCntrId: string): void {
  // if (dicEvent.hasOwnProperty(evtCode)) {
  //   if (dicEvent[evtCode] === null || dicEvent[evtCode] === "") {
  //     dicEvent[evtCode] = pimsCntrId.toString();
  //   } else {
  //     if (!dicEvent[evtCode].includes(pimsCntrId.toString())) {
  //       dicEvent[evtCode] += `,${pimsCntrId}`;
  //     }
  //   }
  // } else {
  //   dicEvent[evtCode] = pimsCntrId.toString();
  // }
  if (!dicEvent.some(x => x.key === evtCode)) {
    dicEvent.push({ key: evtCode, value: pimsCntrId });
  }
  else {
    const findIndex = dicEvent.findIndex(x => x.key === evtCode);
    dicEvent[findIndex].value += `,${pimsCntrId}`;
  }
}

export function CreateCargoEventLog(mblNo: string, evtName: string, kvp: { key: string, value: string }, cntrDataWithSeq: { loc: string, cntrNo: string, seq: number }[], userId: string) {
  const keyArr: string[] = kvp.key.split('|');
  //const eventAt = _.isEmpty(keyArr[1]) ? null : formatDateTime(keyArr[1]);
  const eventAt = _.isEmpty(keyArr[1]) ? null : moment(keyArr[1]).format(CargoEventLog.DateTimeFormat);
  const eventLogs: CargoEventLog[] = [];

  const uniqueCntrSet = new Set(cntrDataWithSeq.map(item => item.cntrNo));
  const uniqueCntrArray = Array.from(uniqueCntrSet);
  uniqueCntrArray.forEach(cntrNo => {
    const result: CargoEventLog = new CargoEventLog(evtName, eventAt ?? '')
    result.suntekID = getFmsGlobal().AcmeID ?? '';
    result.mblNo = mblNo;
    result.cntrNo = cntrNo;
    result.srcEventType = 'ifms';
    result.locName = cntrDataWithSeq.find(x => x.cntrNo === cntrNo)?.loc ?? '';
    //API > TrackingLogMblEvents에서 수행함
    //result.utcTime = nowUtc(); 
    result.timezone =Intl.DateTimeFormat().resolvedOptions().timeZone;
    result.locTime = now() ;
    result.u1Id = userId;

    eventLogs.push(result);
  })
  return eventLogs;
}

export function FindIndexOfKeyStartsWith(dicEvent: { key: string, value: string }[], startWith: string): number {
  let index: number = -1;
  const vStart: string[] = startWith.split(',').map(str => str.trim()).filter(str => str !== '');

  for (let i = 0; i < dicEvent.length; i++) {
    const item = dicEvent[i];
    for (const v of vStart) {
      if (item.key.startsWith(v)) {
        index = i;
        break;
      }
    }

    if (index !== -1) {
      break;
    }
  }
  
  return index;
}